<template>
  <div>
    <div class="flex items-baseline justify-between">
      <h2 class="intro-y text-lg font-medium mt-10">{{ $t("views.supplements.text1") }}</h2>
      <button type="button" class="btn btn-primary w-24 h-10" @click="newSupplementItem">
        {{ $t("views.new") }}
      </button>
    </div>
    <div class="grid grid-cols-12 gap-6 mb-12">
      <div class="intro-y col-span-12 flex flex-wrap sm:flex-nowrap items-center mt-2">
        <p class="mr-auto">{{ $t("views.supplements.text2") }}</p>
        <!-- seleccion  categoria-->
        <div class="cursor w-full sm:w-56 mt-3 sm:mt-0 sm:ml-auto md:ml-0 mr-5">
          <div class="w-full relative text-gray-700 dark:text-gray-300">
            <TomSelect class="w-full cursor" v-model="categorySelected">
              <option value="0">{{ $t("views.all_categories") }}</option>
              <option v-for="(cat, key) in allCategories" :key="key" :value="cat.id">{{ cat.name }}</option>
            </TomSelect>
          </div>
        </div>
        <div class="cursor w-full sm:w-56 mt-3 sm:mt-0 sm:ml-auto md:ml-0 mr-5">
          <!-- seleccion  estado -->
          <div class="w-full relative text-gray-700 dark:text-gray-300">
            <TomSelect class="w-full cursor" v-model="statusFilter">
              <option value="ALL">{{ $t(`globals.all_status.ALL`) }}</option>

              <template v-for="status in allStatus" :key="status">
                <option :value="status">{{ $t(`globals.all_status.${status}`) }}</option>
              </template>
            </TomSelect>
          </div>
        </div>
        <div class="w-full sm:w-auto mt-3 sm:mt-0 sm:ml-auto md:ml-0">
          <div class="w-56 relative text-gray-700 dark:text-gray-300">
            <input
              type="text"
              class="form-control w-56 box pr-10 placeholder-theme-13"
              :placeholder="$t('views.supplements.text4')"
              v-model="searchInput"
            />
            <SearchIcon class="w-4 h-4 absolute my-auto inset-y-0 mr-3 right-0" />
          </div>
        </div>
      </div>
      <!-- BEGIN: Data List -->
      <div class="intro-y col-span-12 overflow-hidden">
        <table class="table table-report -mt-2">
          <thead>
            <tr>
              <th class="whitespace-nowrap">
                <div class="grid supplements__grid">
                  <div class="title__table">{{ $t("views.supplements.text51") }}</div>
                  <div class="title__table">{{ $t("views.supplements.text6") }}</div>
                  <div class="title__table">{{ $t("views.supplements.text94") }}</div>
                </div>
              </th>
              <th class="text-center whitespace-nowrap">{{ $t("views.supplements.text8") }}</th>
            </tr>
          </thead>
          <tbody class="">
            <template v-for="supplement in supplements" :key="supplement.id">
              <tr class="intro-x">
                <td>
                  <div class="grid supplements__grid cursor-pointer" @click="supplement.show = !supplement.show">
                    <!-- nombre a la vista -->
                    <div>{{ supplement.name }}</div>

                    <!-- categoria a la vista -->
                    <div class="flex flex-wrap">
                      <template v-for="(categoryName, catKey) in supplement.categories" :key="catKey">
                        <div
                          class="py-1 px-2 rounded-md text-xs bg-theme-9 text-white cursor-pointer font-medium mr-3 my-1 bg-color-1"
                        >
                          {{ categoryName }}
                        </div>
                      </template>
                    </div>

                    <!-- estado de revision -->
                    <div
                      class="py-1 px-2 rounded-md text-xs font-medium w-max"
                      :class="{
                        'bg-green-500 text-white': supplement.status === 'APPROVED',
                        'bg-red-500 text-white': supplement.status === 'REJECTED',
                        'bg-yellow-300 text-black': supplement.status === 'PENDING_APPROVAL',
                      }"
                    >
                      {{ $t(`globals.all_status.${supplement.status}`) }}
                    </div>
                  </div>
                  <div class="w-full intro-x mt-5" v-if="supplement.show">
                    <!-- nombre quimico -->
                    <h2 v-if="supplement.nameChemical !== ''" class="dark:text-white font-medium mt-3">
                      {{ $t("views.supplements.text49") }}:
                    </h2>
                    <p v-if="supplement.nameChemical !== ''" class="mt-2">{{ supplement.nameChemical }}</p>

                    <!-- tipo /variedad -->
                    <h2 v-if="supplement.type !== ''" class="dark:text-white font-medium mt-2">
                      {{ $t("views.supplements.text50") }}:
                    </h2>
                    <p v-if="supplement.type !== ''" class="mt-3">{{ supplement.type }}</p>

                    <!-- descripcion -->
                    <h2 v-if="supplement.description !== ''" class="dark:text-white font-medium mt-3">
                      {{ $t("views.supplements.text7") }}:
                    </h2>
                    <p v-if="supplement.description !== ''" class="mt-2">{{ supplement.description }}</p>
                  </div>
                </td>
                <td class="table-report__action w-56 relative p-5" style="width: 25px">
                  <div class="flex justify-center items-center">
                    <a class="flex items-center mr-3" href="javascript:;" @click="editSupplementItem(supplement.id)">
                      <CheckSquareIcon class="w-4 h-4 mr-1" />
                      {{ $t("views.edit") }}
                    </a>
                  </div>
                </td>
              </tr>
            </template>
            <tr v-if="loading">
              <td colspan="4" class="p-4">
                {{ $t("views.loading") }}
                <LoadingIcon icon="three-dots" color="currentColor" class="ml-4 inline-block" />
              </td>
            </tr>
            <tr v-if="!loading && supplements.length === 0">
              <td colspan="4" class="p-4">
                {{ $t("views.no_data") }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- END: Data List -->

      <!-- Pagination:start -->
      <PaginationControls
        v-model:page="pagination.page"
        v-model:per_page="pagination.per_page"
        :total_pages="pagination.total_pages"
        :total="pagination.total"
        :sizes="[3, 10, 25, 35, 50]"
        @request="getAll"
      >
        <template #summary>
          {{ $t("components.pagination.viewing", { total: supplements.length }) }}
        </template>
      </PaginationControls>
      <!-- Pagination:end -->
    </div>
  </div>
</template>

<script>
import PaginationControls from "@/components/pagination-control/Main.vue";

import SupplementService from "@/services/supplements.service";
import NutrihubService from "../../services/nutrihub.service";

import _ from "lodash";

export default {
  components: { PaginationControls },
  data() {
    return {
      supplements: [],

      // Filters and states
      searchInput: "",
      allCategories: [],
      allStatus: this.$global.getAllStatus(),
      categorySelected: 0,
      statusFilter: "",

      // UI
      loading: true,
      aspect: this.$global.getAspect(),

      // Pagination data
      pagination: {
        page: 0,
        total_pages: 0,
        per_page: 10,
        total: 0,
      },
    };
  },
  watch: {
    searchInput: _.debounce(function (newSearch, oldSearch) {
      if (newSearch === oldSearch) return;
      this.pagination.page = 0;
      this.getAll();
    }, 500),
    categorySelected: function () {
      this.pagination.page = 0;
      this.getAll();
    },
    statusFilter: function () {
      this.pagination.page = 0;
      this.getAll();
    },
    "$i18n.locale": function (l) {
      this.getInitialData();
    },
  },
  created() {
    this.getInitialData();
  },
  methods: {
    async getInitialData() {
      this.loading = true;

      await Promise.all([this.getAllCategories(), this.getAll()]);

      this.loading = false;
    },
    async getAll() {
      this.loading = true;

      try {
        const newParams = {
          search: this.searchInput.trim() || "",
          page: this.pagination.page,
          per_page: this.pagination.per_page,
          categoryId: this.categorySelected || null,
          status: this.statusFilter || null,
        };
        const { data, pagination } = await NutrihubService.getAllSupplements(newParams);

        this.supplements = (data ?? []).map((s) => this.getSupplementFormatted(s));
        this.paginationSetData(pagination);
      } catch (error) {
        console.error("Error obteniendo los suplementos desde LocalStorage:", error);
      } finally {
        this.loading = false;
      }
    },
    async getAllCategories() {
      try {
        const response = await SupplementService.getCategories();
        this.allCategories = response.data ? response.data : response;
      } catch (e) {
        this.allCategories = [];
      }
    },
    getSupplementFormatted(supplement) {
      return {
        show: false,
        id: supplement.id || "",
        name: supplement.langs[0].value || "",
        nameChemical: supplement.langs[0].chemical_name || "",
        type: supplement.langs[0].family_supplement || "",
        categories: supplement.category_links.map((c) => this.getNameCategoryById(c.id)),
        status: supplement.status || "PENDING_APPROVAL",
        description: supplement.langs[0].description || "",
      };
    },
    editSupplementItem(id) {
      this.$router.push({ path: "/supplement-edit", query: { id } });
    },
    newSupplementItem() {
      this.$router.push({ path: "/supplement-new" });
    },
    getNameCategoryById(id) {
      let cat = this.allCategories.find((c) => c.id == id);
      cat = cat ? cat.name : id;
      return cat;
    },
    // Pagination:start
    paginationSetData({ page = 0, per_page: perPage = 0, total = 0, total_pages: totalPages = 0 } = {}) {
      this.pagination.page = page;
      this.pagination.per_page = perPage;
      this.pagination.total = total;
      this.pagination.total_pages = totalPages;
    },
    // Pagination:end
  },
};
</script>

<style lang="scss" scoped>
.supplements__grid {
  display: grid;
  // Default for smaller screens, adjust as needed
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  align-items: center;
  width: 100%;
  gap: 10px; // Add some gap between items

  @media screen and (min-width: 768px) {
    // Adjust breakpoint for tablets/desktops
    grid-template-columns: 2fr 3fr 1.5fr 1.5fr; // Example for 5 columns on wider screens
  }

  @media screen and (min-width: 1400px) {
    grid-template-columns: 3fr 3fr 1.5fr 1.5fr; // Further adjustment for very wide screens
  }

  .title__table,
  .content__table {
    text-wrap: wrap;
    overflow: hidden; // Ensure text doesn't overflow
    text-overflow: ellipsis; // Add ellipsis for overflowing text
  }
}
</style>

<style scoped>
.cursor {
  cursor: pointer !important;
}

.table td.p-0 {
  padding: 0px !important;
}

.bg-color-1 {
  background-color: #828181;
}

.btn-primary {
  background: #6c869a !important;
  border-color: #6c869a !important;
}

.tom-select .ts-dropdown .option.active {
  background: #6c869a !important;
}

.top-bar .breadcrumb > a:not(.breadcrumb--active) {
  color: #6c869a !important;
}
</style>
